module.exports = __webpack_public_path__ + "static/img/icon_hbsc.997afff5.jpg";